export default __webpack_public_path__ + "static/media/backgroundLogin.7aa6f60f.jpg";